// Cliente API especializado que maneja el unwrapping de respuestas UAU
import axios, { AxiosResponse, AxiosError } from 'axios'

// Configurar axios con la base URL
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// Tipo para respuestas wrapeadas por UAU
interface UAUResponse<T = any> {
  valid: boolean
  data: T
  error?: string
  message?: string
}

// Interceptor de respuesta para unwrapping automático
apiClient.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    // Si la respuesta tiene el formato UAU {valid, data}, extraer data
    if (response.data && typeof response.data === 'object' && 'valid' in response.data && 'data' in response.data) {
      const uauResponse = response.data as UAUResponse

      if (uauResponse.valid) {
        // Reemplazar response.data con los datos unwrapped
        response.data = uauResponse.data
      } else {
        // El error viene en el body de la respuesta 200
        // Convertir a Error con el mensaje para que React Query lo capture
        const errorMsg = uauResponse.error || uauResponse.message || 'Response marked as invalid'
        throw new Error(errorMsg)
      }
    }

    return response
  },
  (error: AxiosError) => {
    // Si el error tiene respuesta, también intentar unwrapping
    if (error.response?.data && typeof error.response.data === 'object' && 'error' in error.response.data) {
      const uauError = error.response.data as UAUResponse
      error.message = uauError.error || uauError.message || error.message
    }

    return Promise.reject(error)
  }
)

// Interceptor de request para agregar token de autenticación
apiClient.interceptors.request.use(
  (config) => {
    // Agregar token si está disponible en localStorage
    const token = localStorage.getItem('camping_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default apiClient